import { customerServerApiClient } from 'utils/apiClient';
import { saasUserCorporationId } from 'utils/consts';

export const countryApi = {
  async getCountries(data: any) {
    const res = await customerServerApiClient.get('country/supported', {
      params: {
        saasUserCorporationId: saasUserCorporationId
      }
    });
    const resBody = res.data;
    return resBody;
  }
};